import styled from 'styled-components';
import { TableCell, TableRow, tableCellClasses, tableRowClasses } from '@mui/material';
import Box from 'component/layoutComponents/Box';
import DefaultUptimeTheme from 'component/theme/defaultTheme';
import TableContainer from '@mui/material/TableContainer';

export const StyledTableContainer: any = styled(TableContainer)`
  ${({ theme, ...props }: { theme: typeof DefaultUptimeTheme }) => `
    .MuiTableCell-root {
      border-right: 1px solid #E0E0E0;
    }
    .MuiTableCell-root:last-child {
      border-right: none;
    }
    border-bottom-left-radius: ${(props as any).isProduct ? "0px" : "8px"};
    border-bottom-right-radius: ${(props as any).isProduct ? "0px" : "8px"};
  `}
`;
export const StyledTableCell = styled(TableCell)`
  ${({ theme }: { theme: typeof DefaultUptimeTheme }) => `
    background-color: #E5ECF6;
    padding: 0 16px;
    &.${tableCellClasses.root}{
      padding: 0 16px;
    }
  `}
`;

export const StyledTableRow = styled(TableRow)(({ theme }: { theme: typeof DefaultUptimeTheme }) => ({
  [`&.${tableRowClasses.root}`]: {
    height: "32px"
  },
}));

export const StyledBoxLinearProgress = styled(Box)<{ isChangeColor: boolean }>(({ theme, isChangeColor }) => `
  min-width: 350px;
  @media(max-width: 580px){
    min-width: 280px;
  }
  .MuiLinearProgress-root {
    margin-top: 12px;
    height: 7px;
    border-radius: 8px;
  }
  .MuiLinearProgress-bar {
    background-color: ${isChangeColor ? "red" : ''}
  }
`);

export const StyledBoxLabel = styled(Box)`
  ${({ theme }: { theme: typeof DefaultUptimeTheme }) => `
    background-color:moccasin;
    height:50px;
    width: 100px
    border:1px solid tomato;
    align-items: center;
  `}
`;

export const StyledRowProduct = styled.div`
  ${({ theme }: { theme: typeof DefaultUptimeTheme }) => `
    width: 100%;
    display: flex;
    overflow: hidden;
    flex-wrap: wrap;
    gap: ${theme.uptimeSpace[3]}px;
  `}
`;

export const StyledProductImage = styled(Box)`
  ${({ theme }: { theme: typeof DefaultUptimeTheme }) => `
    display: flex;
    align-items: center;
    margin-right: 4px;

    img{
      object-fit: contain;
      width: 48px;
      height: 48px;
      mix-blend-mode: multiply;
    }
  `}
`;

export const StyledCardItems = styled(Box)(
  ({ theme }: { theme: typeof DefaultUptimeTheme }) => `
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: ${theme.uptimeSpace[2]}px;
  display:flex;
  align-items: center;
  justify-content: center;
  width: 97.6px;
  height: 64px;
`,
);
export const StyledCardContent = styled(Box)(
  ({ theme }: { theme: typeof DefaultUptimeTheme }) => `
  display: flex;
  background-color: ${theme.uptimeColors.grayScales.grayish};
  height: 96px;
  padding: ${theme.uptimeSpace[8]}px;
  width: 100%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`,
);

export const StyledSelectColumn = styled(Box)(
  ({ theme }: { theme: typeof DefaultUptimeTheme}) => `
    display: flex;
    justify-content: center;
    align-items: center;
  
      ul[role="menu"]{
        background: ${theme.uptimeColors.grayScales.white};
        box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        width: 128px;
        height: 88px;
        flex-direction: column;
        top: 32px;
        left: unset;
        right: 0;
        display: flex;
        border: none;
        @media(max-width: 900px){
          flex-direction: column;
          height: unset;
        }
        button[role="menuitem"]{
          width: 100%;
          color: ${theme.uptimeColors.grayScales.black};
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0.4px;
          &:hover{
            background: transparent;
            text-decoration: underline;
          }
          @media(max-width: 900px){
            &:first-child{
              color: ${theme.uptimeColors.grayScales.darkestGray};
              border-bottom: 1px solid rgba(0, 0, 0, 0.12);
            }
          }
        }
      }
  `
);
